import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
  Box,
} from "@mui/material";
import "./cookiesPolicy.css";
import Header from "../../components/Header";
import { Footer } from "../../components/Footer";

const cookiesPolicyData = [
  {
    question: "What are cookies?",
    answer:
      "Cookies are small text files stored on your device to help us improve your experience on our website.",
  },
  {
    question: "How do we use cookies?",
    answer:
      "We use cookies to remember user preferences, track website performance, and analyze traffic.",
  },
  {
    question: "Types of cookies we use",
    answer:
      "Essential, performance, functionality, and targeting cookies may be used depending on your interactions with our site.",
  },
  {
    question: "Managing your cookie preferences",
    answer:
      "You can adjust your cookie settings through your browser or use our website cookie consent banner.",
  },
];

export const CookiesPolicy = () => {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panelIndex) => (event, isExpanded) => {
    setExpanded(isExpanded ? panelIndex : false);
  };
  return (
    <>
      <Header />
      <section className="csm_page_wrapper_cokkies mt-10">
        <div className="faq_container" style={{ marginTop: "100px" }}>
          <h1 className="csm_page_title">Cookies Policy</h1>{" "}
          <div className="accordion-container">
          {cookiesPolicyData?.map((faq, index) => (
            <Accordion
              key={index}
              expanded={expanded === index}
              onChange={handleChange(index)}
              className="mb-3"
            >
              <AccordionSummary
                // expandIcon={<i className="fas fa-plus"></i>}
                expandIcon={
                  expanded === index ? (
                    <i className="fas fa-minus"></i>
                  ) : (
                    <i className="fas fa-plus"></i>
                  )
                }
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
              >{faq.question}</AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2">{faq.answer}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default CookiesPolicy;
